import { defaultAgent, apiResponse } from '../helpers/web-agent';
import { toastInfo, toastError, toastSuccess } from './toast';
import { tokenExpired } from './auth';
import { getRequestParams } from './analyze';
import { getSearchDateRange } from '../helpers/common';
import { VIEW_EG } from '../constants';
import {
    EG_GET_PLANNED_DATE_REQUEST, EG_GET_PLANNED_DATE,
    GET_EQUIPMENT_GROUP_LIST_REQUEST, GET_EQUIPMENT_GROUP_LIST, EQUIPMENT_GROUP_FAILURE,
    EQUIPMENT_GROUP_SUCCESS, EQUIPMENT_GROUP_FORM_CLEAR, GET_CREW_EQUIPMENT_GROUP_LIST,
    LOAD_HISTORY, SET_AUTOMATIC_LOAD_COUNT, CLEAR_EQUIPMENT_GROUP_LIST, GET_HARVESTER_LIST, GET_LOAD_HISTORY_REQUEST, GET_GEO_SHAPE_LIST,
    EG_GET_REGION_LIST_REQUEST, EG_GET_REGION_LIST, EG_GET_WORKED_ACRES_REQUEST, EG_GET_WORKED_ACRES,
    SET_BULK_LOAD, EDIT_BULK_LOAD, REMOVE_BULK_LOAD, CLEAR_BULK_LOAD, EDIT_BULK_LOADS, SET_SELECTED_EQUIPMENT_GROUP, SET_SELECTED_EG, SET_ROUNDTRIP_DETAIL,
    SET_ROUNDTRIP_REQUEST, DELETED_LOAD_HISTORY_REQUEST, DELETED_LOAD_HISTORY, SET_RESTORE_LOAD, SET_DELETED_LOAD, EG_REPORT_ISSUE, EG_REPORT_ISSUE_REQUEST, SET_EG_REGION_LOCATION, SET_EG_REGION_LOCATION_REQUEST, LOAD_HISTORY_HEADER, SET_EG_REGION_LOCATION_LOG, SET_EG_REGION_LOCATION_LOG_REQUEST, GET_ALL_EQUIPMENT_GROUP_LIST_REQUEST, GET_ALL_EQUIPMENT_GROUP_LIST
} from '../constants/action-types';
import {
    EQUIPMENT_GROUP_CREATED, EQUIPMENT_GROUP_EDITED,
    EQUIPMENT_GROUP_DELETED, RECORD_FOUND, LOAD_EDITED, LOAD_NOTES_SAVED, LOAD_DELETED, BULK_LOAD_SAVED, BULK_LOAD_EDITED,
    LOAD_RESTORED, NO_RECORD_FOUND, LOAD_ADDED,
    EQUIPMENT_GROUP_RATE_SAVE
} from '../constants/messages';
import moment from 'moment';

export const plannedDateRequest = (id) => ({ type: EG_GET_PLANNED_DATE_REQUEST, id });

export const plannedDate = (id, data) => ({ type: EG_GET_PLANNED_DATE, id, payload: data });

export const equipmentGroupListRequest = () => ({ type: GET_EQUIPMENT_GROUP_LIST_REQUEST });

export const equipmentGroupList = (data = []) => ({ type: GET_EQUIPMENT_GROUP_LIST, payload: data });

export const selectedEquipmentGroup = (data) => ({ type: SET_SELECTED_EQUIPMENT_GROUP, payload: data });

export const setSelectedEG = (data) => ({ type: SET_SELECTED_EG, payload: data });

export const harvesterList = (data = []) => ({ type: GET_HARVESTER_LIST, payload: data });

export const crewEquipmentGroupList = (isFetching, data) => ({ type: GET_CREW_EQUIPMENT_GROUP_LIST, isFetching, payload: data });

export const geoShapeList = (data = []) => ({ type: GET_GEO_SHAPE_LIST, payload: data });

export const equipmentGroupFailure = (data) => ({ type: EQUIPMENT_GROUP_FAILURE, payload: data });

export const equipmentGroupSuccess = () => ({ type: EQUIPMENT_GROUP_SUCCESS });

export const equipmentGroupClear = () => ({ type: EQUIPMENT_GROUP_FORM_CLEAR });

export const loadHistoryRequest = () => ({ type: GET_LOAD_HISTORY_REQUEST });

export const loadHistory = data => ({ type: LOAD_HISTORY, payload: data });

export const deletedLoadHistoryRequest = () => ({ type: DELETED_LOAD_HISTORY_REQUEST });

export const deletedLoadHistory = data => ({ type: DELETED_LOAD_HISTORY, payload: data });

export const setDeletedLoad = (loadActivityId) => ({ type: SET_DELETED_LOAD, loadActivityId });

export const setRestoreLoad = (loadActivityId, restoredDate) => ({ type: SET_RESTORE_LOAD, loadActivityId, restoredDate });

export const setAutomaticLoadCount = payload => ({ type: SET_AUTOMATIC_LOAD_COUNT, payload });

export const regionListRequest = () => ({ type: EG_GET_REGION_LIST_REQUEST });

export const regionList = (data) => ({ type: EG_GET_REGION_LIST, payload: data });

export const workedAcresRequest = () => ({ type: EG_GET_WORKED_ACRES_REQUEST });

export const workedAcres = (data) => ({ type: EG_GET_WORKED_ACRES, payload: data });

export const clearEquipmentGroupList = () => ({ type: CLEAR_EQUIPMENT_GROUP_LIST });

export const setBulkLoad = (loadActivityId) => ({ type: SET_BULK_LOAD, loadActivityId });

export const editBulkLoad = (loadActivityId, data) => ({ type: EDIT_BULK_LOAD, loadActivityId, payload: data });

export const editBulkLoads = (data) => ({ type: EDIT_BULK_LOADS, payload: data });

export const removeBulkLoad = (data) => ({ type: REMOVE_BULK_LOAD, payload: data });

export const clearBulkLoad = () => ({ type: CLEAR_BULK_LOAD });

export const setRoundTripDetails = (data) => ({ type: SET_ROUNDTRIP_DETAIL, payload: data });

export const setRoundTripRequest = () => ({ type: SET_ROUNDTRIP_REQUEST });

export const EGReportIssue = (data) => ({ type: EG_REPORT_ISSUE, payload: data });
export const EGReportIssueRequest = () => ({ type: EG_REPORT_ISSUE_REQUEST });

export const SetEGRegionLocation = (data) => ({ type: SET_EG_REGION_LOCATION, payload: data });
export const SetEGRegionLocationRequest = () => ({ type: SET_EG_REGION_LOCATION_REQUEST });

export const SetEGRegionLocationLog = (data) => ({ type: SET_EG_REGION_LOCATION_LOG, payload: data });
export const SetEGRegionLocationLogRequest = () => ({ type: SET_EG_REGION_LOCATION_LOG_REQUEST });

export const setLoadHistoryHeader = payload => ({ type: LOAD_HISTORY_HEADER, payload });

export const allEquipmentGroupListRequest = () => ({ type: GET_ALL_EQUIPMENT_GROUP_LIST_REQUEST });
export const allEquipmentGroupList = (data = []) => ({ type: GET_ALL_EQUIPMENT_GROUP_LIST, payload: data });

export const getEgRoundTrip = (data) => (dispatch) => {
    dispatch(setRoundTripRequest());
    const params = {
        farm_uuid: data.farmId,
        start_date: data.startDate,
        end_date: data.endDate,
    };

    dispatch(plannedDateRequest(params.farmId));
    defaultAgent.get(`api/equipment/group/region-location/trips`, params)
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
            } else if (agentResult.data) {
                dispatch(setRoundTripDetails(agentResult.data));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
};

export const getPlanPlannedDate = (params, cb = null) => (dispatch) => {
    dispatch(plannedDateRequest(params.farmId));
    defaultAgent.get(`api/plan/plannedDate`, { farm_uuid: params.farmId, range_type: params.range })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(plannedDate(params.farmId));
                if (cb) cb();
            } else if (agentResult.data) {
                dispatch(plannedDate(params.farmId, agentResult.data));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(plannedDate(params.farmId));
            if (cb) cb();
        });
};

export const createEquipmentGroup = (data, cb = null) => {
    return dispatch => {
        defaultAgent.post('/api/equipment/group/v1/add', data)
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.code === EQUIPMENT_GROUP_CREATED.code) {
                    if (cb) cb();
                    dispatch(toastSuccess(agentResult.message));
                    dispatch(equipmentGroupSuccess());
                    dispatch(getEquipmentGroupList({ farmId: data.farm_uuid }));
                } else if (agentResult.message) {
                    dispatch(equipmentGroupFailure({ message: agentResult.message }));
                }
            }).catch(ex => {
                dispatch(toastError(ex.message));
            });
    }
}

export const editEquipmentGroup = (data, cb = null) => {
    return dispatch => {
        defaultAgent.put('/api/equipment/group/v1/edit', data)
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.code === EQUIPMENT_GROUP_EDITED.code) {
                    if (cb) cb();
                    dispatch(toastSuccess(agentResult.message));
                    dispatch(getEquipmentGroupList({ farmId: data.farm_uuid }));
                } else if (agentResult.message) {
                    dispatch(equipmentGroupFailure({ message: agentResult.message }));
                }
            }).catch(ex => {
                dispatch(toastError(ex.message));
            });
    }
}

export const deleteEquipmentGroup = (data) => {
    return dispatch => {
        defaultAgent.put('/api/equipment/group/v1/delete', { equipment_group_uuid: data.equipment_group_uuid, farm_uuid: data.farm_uuid })
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.code === EQUIPMENT_GROUP_DELETED.code) {
                    dispatch(toastInfo(agentResult.message));
                    dispatch(getEquipmentGroupList({ farmId: data.farm_uuid }));
                } else if (agentResult.message) {
                    dispatch(toastError(agentResult.message));
                }
            }).catch(ex => {
                dispatch(toastError(ex.message));
            });
    }
}

export const getEquipmentGroupList = (params, cb = null) => (dispatch, getState) => {
    const search = getState().analyze.searchParams;
    const dateInfo = getSearchDateRange(search);

    const reqParams = {
        farm_uuid: params && params.farmId ? params.farmId : null,
        from_date: dateInfo.from,
        to_date: dateInfo.to,
        crew: ((params && params.crew) || 1),
        device: ((params && params.device) || 1),
        ...(params && params.selectedPlanType && params.selectedPlanType !== 10) && {
            plan_type_id: params && params.selectedPlanType
        },
        vehicle_spec: 1,
    };

    dispatch(equipmentGroupListRequest());
    defaultAgent.get('/api/equipment/group/v1/list', reqParams, { requestId: "subEquipmentGroupList" })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(equipmentGroupList());
            } else if (agentResult.data) {
                if (!!cb) cb(agentResult.data)
                dispatch(equipmentGroupList(agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Sub Equipment Group List: ', ex.message);
            dispatch(toastError(ex.message));
            dispatch(equipmentGroupList());
        });
}

export const getCrewEquipmentGroupList = ({ farmId, planTypeId }) => {
    const params = { farm_uuid: farmId, plan_type_id: planTypeId };
    return dispatch => {
        dispatch(crewEquipmentGroupList(true));
        defaultAgent.get('/api/equipment/group/withcrew/list', params).then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(crewEquipmentGroupList());
            } else if (agentResult.data) {
                dispatch(crewEquipmentGroupList(false, agentResult.data));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(crewEquipmentGroupList());
        });
    }
}

export const getLoadHistory = data => dispatch => {
    const req = getRequestParams(data);
    if (!req.apiName) return dispatch(loadHistory());

    let reqParams = { ...req.params, __t: new Date().getTime() };
    if (data.view === VIEW_EG) {
        delete reqParams.equipment_group_uuid;
        reqParams = data.isTruck ?
            { ...reqParams, target_equipment_group_uuid: data.egId } :
            { ...reqParams, source_equipment_group_uuid: data.egId };
    }

    dispatch(loadHistoryRequest());
    defaultAgent.get(`/api${req.apiName}/load/v1/history`, reqParams, { requestId: "loadHistoryForCSV" }).then(res => {
        const agentResult = apiResponse(res);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            dispatch(loadHistory());
        } else if (agentResult.data) {
            dispatch(loadHistory(agentResult.data));
        }
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log('Load History CSV: ', ex.message);
        dispatch(toastError(ex.message));
        dispatch(loadHistory());
    });
}

export const getDeletedLoadHistory = data => dispatch => {
    const req = getRequestParams(data);
    if (!req.apiName) return dispatch(deletedLoadHistory());

    let reqParams = { ...req.params, __t: new Date().getTime() };
    if (data.view === VIEW_EG) {
        delete reqParams.equipment_group_uuid;
        reqParams = data.isTruck ?
            { ...reqParams, target_equipment_group_uuid: data.egId } :
            { ...reqParams, source_equipment_group_uuid: data.egId };
    }

    dispatch(deletedLoadHistoryRequest());
    defaultAgent.get(`/api${req.apiName}/load/delete/history`, reqParams, { requestId: "deletedLoadHistory" }).then(res => {
        const agentResult = apiResponse(res);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            dispatch(deletedLoadHistory());
        } else if (agentResult.data) {
            dispatch(deletedLoadHistory(agentResult.data));
        }
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log('Deleted Load History : ', ex.message);
        dispatch(toastError(ex.message));
        dispatch(deletedLoadHistory());
    });
}

export const getGeoRegionList = (params, cb) => dispatch => {
    dispatch(regionListRequest());
    defaultAgent.get('/api/geo/region/list', { farm_uuid: params.farmId })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(regionList([]));
                dispatch(toastError(agentResult.message));
            }
            else if (agentResult.data) {
                dispatch(regionList(agentResult.data));
                if (cb) cb();
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(regionList([]));
        });
}

export const getWorkedAcres = (params) => dispatch => {
    if (!params.fromDate || !params.toDate) return dispatch(workedAcres());
    const reqParams = {
        farm_uuid: params.farmId,
        start_date: moment.utc(params.fromDate).startOf('day').format(),
        end_date: moment.utc(params.toDate).endOf('day').format()
    };

    dispatch(workedAcresRequest());
    defaultAgent.post(`/api/farm/region-covered-summary`, reqParams, { timeout: 2 * 60 * 1000 })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.status === 'error') {
                dispatch(workedAcres());
                dispatch(toastError(agentResult.message));
            }
            else if (agentResult.code === RECORD_FOUND.code) {
                dispatch(workedAcres(agentResult.data));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(workedAcres());
        });
}

export const getHarvesterList = ({ farmId, selectedPlanType }) => dispatch => {
    const params = { farm_uuid: farmId, spec: 0, operator: 0, crew: 0, device: 0, img: 0, plan_type_id: selectedPlanType };
    defaultAgent.get('/api/equipment/group/v1/list', params)
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(harvesterList());
            } else if (agentResult.data) {
                const harvesterIds = [9, 27, 28, 31, 34, 43, 44];
                if (selectedPlanType === 2) harvesterIds.push(12);
                const filteredList = agentResult.data.filter(e => harvesterIds.indexOf(e.primary_category_id) >= 0);
                dispatch(harvesterList(filteredList));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(harvesterList());
        });
}

export const getGeoShapeList = farmId => dispatch => {
    const params = {
        farm_uuid: farmId,
        include_location: false,
        include_properties: false,
    };

    defaultAgent.get(`/api/geo/shape/list`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(geoShapeList());
            } else if (agentResult.data) {
                dispatch(geoShapeList(agentResult.data));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(geoShapeList());
        });
};

export const editLoad = (params, cb) => dispatch => {

    let APIName = 'equipment/group';
    if (params && params.planTypeId) {
        switch (params.planTypeId) {
            case 5:
                APIName = 'logistics';
                break;
            case 2:
                APIName = 'seed';
                break;
            default:
                break;
        }
    };

    defaultAgent.put(`/api/${APIName}/load/edit`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === LOAD_EDITED.code) {
                dispatch(toastSuccess(agentResult.message));
                if (cb) cb(true, params);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            if (cb) cb(false);
        });
};

export const addLoad = (params, cb) => dispatch => {
    defaultAgent.post(`/api/equipment/group/load/add`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === LOAD_ADDED.code) {
                dispatch(toastSuccess(agentResult.message));
                if (cb) cb(true);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            if (cb) cb(false);
        });
};

export const saveLoadNotes = (params, cb) => dispatch => {
    defaultAgent.put(`/api/equipment/group/load/notes/save`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === LOAD_NOTES_SAVED.code) {
                if (cb) cb(true);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            if (cb) cb(false);
        });
};

export const deleteLoad = (params, cb) => dispatch => {
    defaultAgent.put(`/api/equipment/group/load/delete`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === LOAD_DELETED.code) {
                dispatch(toastSuccess(agentResult.message));
                if (cb) cb(true);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            if (cb) cb(false);
        });
}

export const restoreDeletedLoad = (params, cb) => dispatch => {
    defaultAgent.put(`/api/equipment/group/load/restore`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === LOAD_RESTORED.code) {
                dispatch(toastSuccess(agentResult.message));
                if (cb) cb(true);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            if (cb) cb(false);
        });
}

export const saveBulkLoad = (params, cb) => dispatch => {
    defaultAgent.post('/api/equipment/group/load/bulk', params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === BULK_LOAD_SAVED.code) {
                dispatch(toastSuccess(BULK_LOAD_SAVED.message));
                dispatch(clearBulkLoad());
                if (cb) cb();
            } else if (agentResult.message) {
                dispatch(dispatch(toastError(agentResult.message)));
                if (cb) cb();
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            if (cb) cb();
        });
};


export const editBulkLoadList = (params, cb) => dispatch => {
    defaultAgent.put('/api/equipment/group/load/edit/bulk', params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === BULK_LOAD_EDITED.code) {
                dispatch(toastSuccess(BULK_LOAD_EDITED.message));
                if (cb) cb();
            } else if (agentResult.message) {
                dispatch(dispatch(toastError(agentResult.message)));
                if (cb) cb();
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            if (cb) cb();
        });
};

export const getAutomaticLoad = params => dispatch => {
    if (!params.fromDate || !params.toDate) return;
    const reqParams = {
        farm_uuid: params.farmId,
        start_date: moment.utc(params.fromDate).startOf('day').format(),
        end_date: moment.utc(params.toDate).endOf('day').format()
    };
    let apiName = null;

    if (params.egId) {
        apiName = 'equipment/group';
        reqParams.equipment_group_uuid = params.egId;
    } else if (params.crewId) {
        apiName = 'crew';
        reqParams.crew_uuid = params.crewId;
    } else apiName = 'farm';

    defaultAgent.get(`api/${apiName}/load/estimate/summary`, reqParams, { requestId: "analyseAutomaticLoad" })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(setAutomaticLoadCount());
            } else if (agentResult.data) {
                dispatch(setAutomaticLoadCount(agentResult.data.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Analyse Automatic Load: ', ex.message);
            dispatch(toastError(ex.message));
            dispatch(setAutomaticLoadCount());
        });
};

export const getEGReportIssue = (farmId) => dispatch => {
    dispatch(EGReportIssueRequest());
    defaultAgent.get(`/api/equipment/group/report/issue`, { farm_uuid: farmId })
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === RECORD_FOUND.code) {
                dispatch(EGReportIssue(agentResult.data));
            } else if (agentResult.code === NO_RECORD_FOUND.code) {
                dispatch(EGReportIssue(null));
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
};

export const getEGRegionLocation = (params) => dispatch => {
    dispatch(SetEGRegionLocationRequest());
    defaultAgent.post(`/api/equipment/group/region-location`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === RECORD_FOUND.code) {
                if (agentResult.data && agentResult.data.hasOwnProperty("data")) {
                    dispatch(SetEGRegionLocation(
                        { [params.equipment_group_uuid]: agentResult.data.data }
                    ));
                } else dispatch(SetEGRegionLocation(null));
            } else if (agentResult.code === NO_RECORD_FOUND.code) {
                dispatch(SetEGRegionLocation(null));
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
};

export const getEGRegionLocationLog = (params) => dispatch => {
    dispatch(SetEGRegionLocationLogRequest());
    defaultAgent.post(`/api/equipment/group/region-location/log`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === RECORD_FOUND.code) {
                if (agentResult.data && agentResult.hasOwnProperty("data")) {
                    dispatch(SetEGRegionLocationLog(
                        { [params.equipment_group_uuid]: agentResult.data }
                    ));
                } else dispatch(SetEGRegionLocationLog(null));
            } else if (agentResult.code === NO_RECORD_FOUND.code) {
                dispatch(SetEGRegionLocationLog(null));
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
};

export const getAllEquipmentGroupList = (params, cb = null) => (dispatch, getState) => {
    const search = getState().analyze.searchParams;
    const dateInfo = getSearchDateRange(search);

    const reqParams = {
        farm_uuid: params.farmId,
        from_date: dateInfo.from,
        to_date: dateInfo.to,
        crew: (params.crew || 1),
        device: (params.device || 1),
        ...params.selectedPlanType && params.selectedPlanType !== 10 && {
            plan_type_id: params.selectedPlanType
        }
    };

    dispatch(allEquipmentGroupListRequest());
    defaultAgent.get('/api/equipment/group/v1/list', reqParams, {})
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(allEquipmentGroupList());
            } else if (agentResult.data) {
                if (!!cb) cb(agentResult.data)
                dispatch(allEquipmentGroupList(agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Sub Equipment Group List: ', ex.message);
            dispatch(toastError(ex.message));
            dispatch(allEquipmentGroupList());
        });
}

export const saveEquipmentGroupRates = (params, cb) => dispatch => {
    defaultAgent.put(`/api/equipment/group/load/rate/update`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === EQUIPMENT_GROUP_RATE_SAVE.code) {
                if (cb) cb(true);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            if (cb) cb(false);
        });
};

export const calculateEgLoadDistance = (params, cb) => dispatch => {
    defaultAgent.put(`/api/equipment/group/load/distance/update`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === EQUIPMENT_GROUP_RATE_SAVE.code) {
                if (cb) cb(true);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            if (cb) cb(false);
        });
};